var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.859 4.23c.359-1.106 1.923-1.106 2.282 0l.968 2.978a.4.4 0 0 0 .38.276h3.133c1.162 0 1.646 1.488.705 2.171l-2.534 1.841a.4.4 0 0 0-.145.447l.968 2.98c.359 1.105-.906 2.024-1.847 1.341l-2.534-1.841a.4.4 0 0 0-.47 0L7.23 16.264c-.94.683-2.206-.236-1.847-1.342l.968-2.979a.4.4 0 0 0-.145-.447l-2.534-1.84c-.94-.684-.457-2.172.705-2.172H7.51a.4.4 0 0 0 .38-.276l.969-2.979Zm1.521.246a.4.4 0 0 0-.76 0l-.968 2.98a1.2 1.2 0 0 1-1.142.828H4.378a.4.4 0 0 0-.235.724l2.534 1.841a1.2 1.2 0 0 1 .436 1.342l-.968 2.979a.4.4 0 0 0 .616.447l2.534-1.841a1.2 1.2 0 0 1 1.41 0l2.534 1.84a.4.4 0 0 0 .616-.446l-.968-2.98a1.2 1.2 0 0 1 .436-1.34l2.534-1.842a.4.4 0 0 0-.235-.724H12.49a1.2 1.2 0 0 1-1.142-.829l-.968-2.979Z",
    fill: "currentColor"
  })));
};
export default SvgStar;